<template>
  <div>
    <el-dialog class="register" :visible.sync="$store.state.isRegisterShow" :close-on-click-modal="false">
      <div class="loginBox fontPB">
        <div class="boxItem">
          <div class="title">
            <div>{{ $t('dialog.signup') }}</div>
          </div>
          <el-form labelPosition="top" ref="regForm" :model="form" :rules="rules">
            <el-form-item prop="username" :error="errs.username">
              <div class="formLabel" solt="label">{{ $t('dialog.name') }}</div>
              <el-input :placeholder="$t('dialog.name')" v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item prop="email" :error="errs.email">
              <div class="formLabel" solt="label">{{ $t('dialog.email') }}</div>
              <el-input placeholder="you@example.com" v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item prop="phone" :error="errs.phone">
              <div class="formLabel" solt="label">{{ $t('dialog.phoneNumber') }}</div>
              <el-input :placeholder="$t('dialog.pphone')" v-model.number="form.phone">
                <el-select v-model="areaCode" filterable slot="prepend" :placeholder="$t('dialog.pselect')">
                  <el-option
                    v-for="item in areaCodeList"
                    :key="item.areaCode"
                    :label="`+${item.areaCode}`"
                    :value="`+${item.areaCode}`">
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <div class="formLabel" solt="label">{{ $t('dialog.pass') }}</div>
              <el-input show-password :placeholder="$t('dialog.char')" v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <div class="formLabel" solt="label">{{ $t('dialog.cpass') }}</div>
              <el-input show-password :placeholder="$t('dialog.char')" v-model="form.confirmPassword"></el-input>
            </el-form-item>
          </el-form>
          <el-checkbox class="remember fontPM" v-model="form.is_newsletter">{{
              $t('dialog.newsletterCheck')
            }}
          </el-checkbox>
          <div class="iconGroup">
            <el-button class="reg fontMB" plain @click="register()">
              {{ $t('dialog.reg') }}
            </el-button>
          </div>
          <div class="tips">
            {{ $t('dialog.warn') }}
            <router-link to="/T&C" @click.native="$store.commit('changeRegisterShow',false)">{{
                $t('dialog.terms')
              }}
            </router-link>
          </div>
        </div>
        <!-- 其他方式注册 -->
        <div class="boxItem">
          <div class="otherTitle">
            <div class="line"></div>
            <div class="signUp fontMR">{{ $t('dialog.signWith') }}</div>
            <div class="line"></div>
          </div>
          <div class="otherIcons fontMB">
            <el-button icon="el-icon-google"
                       style="width: 48%;height: 40px;color:#DB4437;background-color: #fff;border-color:#DB4437;"
                       @click="googleLogin();">
              <span>{{ $t('dialog.google') }}</span>
            </el-button>
            <!-- <el-button icon="el-icon-fb" style="width: 48%;height: 40px;color:#3B5998;background-color: #fff;border-color:#3B5998;" plain @click="faceLogin();">
              <span>{{$t('dialog.face')}}</span>
            </el-button> -->
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 手機驗證碼驗證 -->
    <el-dialog class="verification" :visible.sync="showVerification"
               @close="closeDialog()"
               width="90%" :title="$t('dialog.phoneVerification')" :close-on-click-modal="false">
      <div style="text-align:center;margin-bottom: 20px;">
        <p class="verificationContent">{{ $t('dialog.codeTo') }} {{ areaCode }} {{ form.phone }}</p>
        <p class="verificationContent">{{ $t('dialog.checkCode') }}</p>
      </div>
      <el-input :placeholder="$t('dialog.code')" v-model.number="verificationCode"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="times!=0" @click="sendAgain()">
          {{ $t('dialog.sendAgain') }}
          <span v-if="times">({{ times }}s)</span>
        </el-button>
        <el-button type="warning" @click="confirm()">{{ $t('btnText.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import areaCodeList from '../assets/area/data';

export default {
  data () {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('dialog.pname')));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value === '') {
        callback(new Error(this.$t('dialog.pemail')));
      } else if (!myreg.test(value)) {
        callback(new Error(this.$t('dialog.pvemail')));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('dialog.ppass')));
      } else if (value.length < 6) {
        callback(new Error(this.$t('dialog.p6pass')));
      } else {
        this.$refs.regForm.validateField('confirmPassword');
        callback();
      }
    };
    var validateCP = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('dialog.pcpass')));
      } else if (value !== this.form.password) {
        callback(new Error(this.$t('dialog.ptpass')));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      // var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value === '') {
        callback(new Error(this.$t('dialog.pphone')));
      }
        // else if(!myreg.test(value)){
        //     callback(new Error(this.$t('dialog.pvemail')));
      // }
      else {
        callback();
      }
    };
    return {
      times: 60,
      form: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        is_newsletter: false,
        language: (this.$i18n.locale == 'zh-CN' || this.$i18n.locale == 'zh-TW') ? this.$i18n.locale : 'en',
      },
      rules: {
        username: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: validateCP, trigger: 'blur' },
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
      },
      errs: {
        username: '',
        email: '',
        phone: '',
      },
      verificationCode: '',
      showVerification: false,
      areaCode: '',
      areaCodeList: areaCodeList.province_list,
    };
  },
  mounted () {
    // this.getAreaCode()
  },
  methods: {
    // verifyEmail(){
    // 	this.$axios({
    // 		method: "get",
    // 		url: `/api/exist_email?email=${this.form.email}`,
    // 	}).then(res=>{
    // 		if(res.data.exist == 1){
    // 			this.errs.email = "邮箱已经存在"
    // 		}
    // 	})
    // },
    getTime () {
      this.timer = setInterval(() => {
        this.times--;
        console.log(this.times);
        if (this.times <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    getAreaCode () {
      this.$axios({
        method: 'GET',
        url: '/api/codes',
      }).then((res) => {
        this.areaCodeList = res;
      });
    },
    register () {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          if (this.areaCode) {
            this.$axios({
              method: 'get',
              url: `/api/exist_email?email=${this.form.email}`,
            }).then(res => {
              if (res.data.exist == 1) {
                this.$message.error('邮箱已经存在');
              } else {
                // let areaCode = this.areaCode == "86" ? '' : this.areaCode
                this.$axios({
                  method: 'post',
                  url: '/api/send_verify_code',
                  data: {
                    phone_area_code: this.areaCode,
                    phone: this.form.phone,
                  },
                }).then(res => {
                  console.log(res, 'code');
                  this.showVerification = true;
                  this.times = 60;
                  this.getTime();
                });
              }
            });

          } else {
            // this.$message.error(this.$t("dialog.pselectinfo"))
            this.errs.phone = this.$t('dialog.pselectinfo');
          }

        } else {
          return;
        }
      });
    },
    googleLogin () {
      this.ga.event('register', 'submit', 'google');
      fbq('track', 'register', { content_name: 'google' });
      window.location.href = 'https://www.wennoanimal.com/api/google';
    },
    faceLogin () {
      this.ga.event('register', 'submit', 'facebook');
      fbq('track', 'register', { content_name: 'facebook' });
      window.location.href = 'https://www.wennoanimal.com/api/facebook';
    },
    // 再次发送验证码回调
    sendAgain () {
      let areaCode = this.areaCode == '86' ? '' : this.areaCode;
      this.$axios({
        method: 'post',
        url: '/api/send_verify_code',
        data: {
          phone_area_code: areaCode,
          phone: this.form.phone,
        },
      }).then(res => {
        console.log(res, 'code');
        this.times = 60;
        this.getTime();
      });
    },
    // 关闭手机验证对话框
    closeDialog () {
      clearInterval(this.timer);
    },
    confirm () {
      if (this.form.is_newsletter) {
        this.form.is_newsletter = 1;
      } else {
        this.form.is_newsletter = 0;
      }
      this.errs.username = '';
      this.errs.email = '';
      // let areaCode = this.areaCode == "86" ? '' : this.areaCode
      this.$axios({
        method: 'post',
        url: '/api/users',
        data: {
          email: this.form.email,
          password: this.form.password,
          username: this.form.username,
          is_newsletter: this.form.is_newsletter,
          verify_code: this.verificationCode,
          phone: this.form.phone,
          phone_area_code: this.areaCode,
        },
      }).then(res => {
        this.$message({
          message: this.$t('dialog.registerSuccess'),
          type: 'success',
          duration: 1800,
          offset: 200,
        });
        this.$refs.regForm.resetFields();
        this.$store.commit('changeRegisterShow', false);
        this.ga.event('register', 'submit', 'email');
        fbq('track', 'register', { content_name: 'email' });
        this.showVerification = false;
        // this.$store.commit('changeLoginShow',false);
        this.$store.commit('changeRegisterShow', false);
      }).catch(error => {
        if (error.response.data.errors) {
          for (var key in error.response.data.errors) {
            this.errs[key] = error.response.data.errors[key][0];
          }
        }
      });

    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog {
  width : 70%;
}

/deep/ .register .el-dialog__header {
  padding : 0;
}

/deep/ .remember .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .remember .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color : #fec353;
  border-color     : #fec353;
  color            : #fec353;
}

/deep/ .remember .el-checkbox__label {
  font-size : 12px;
}

/deep/ .remember .el-checkbox__input.is-checked + .el-checkbox__label {
  color : #fec353;
}

.dialog-footer button {
  padding : 5px 10px;
}

.dialog-footer {
  display         : flex;
  justify-content : space-between;
}

.loginBox {
  width           : 100%;
  min-height      : 300px;
  display         : flex;
  align-items     : flex-start;
  justify-content : space-between;
  color           : #000;
}

.boxItem {
  width      : 45%;
  min-height : 300px;
}

.title {
  height : 40px;
}

.title > div {
  font-size : 30px;
  color     : #010D3E;
}

.title > p {
  line-height : 30px;
  font-size   : 16px;
}

.title > p > span:hover {
  cursor : pointer;
}

.title > p > span {
  color : #fec353;
}

.tips {
  text-align : center;
  color      : rgb(97, 94, 94);
}

/deep/ .is-disabled.reg {
  background-color : #C0C4CC;
  color            : #fff;
  border-color     : #fff;
}

/deep/ .is-disabled.reg:hover {
  background-color : #C0C4CC;
  color            : #fff;
  border-color     : #fff;
}

.reg, .reg:hover, .reg:active, .reg:focus, .reg:visited {
  width            : 100%;
  height           : 40px;
  color            : #fff;
  border-color     : #409EFF;
  background-color : #fec353;
}

.formLabel {
  height      : 30px;
  line-height : 30px;
  color       : #000;
  font-size   : 16px;
}

.iconGroup {
  height          : 60px;
  display         : flex;
  align-items     : center;
  justify-content : space-between;
}

.otherTitle {
  height          : 20px;
  margin-top      : 41px;
  display         : flex;
  align-items     : center;
  justify-content : center;
}

.signUp {
  width      : 100px;
  height     : 20px;
  text-align : center;
  font-size  : 14px;
  color      : #D0D0E4;
}

.line {
  flex             : auto;
  height           : 1px;
  background-color : #D0D0E4;
}

.otherIcons {
  height          : 60px;
  display         : flex;
  align-items     : center;
  justify-content : space-around;
}

.el-select {
  width : 100px;
}

/*手机*/
@media screen and (max-width : 768px) {
  /deep/ .el-dialog {
    width : 85%;
  }

  .loginBox {
    display : block;
  }

  .boxItem {
    width      : 100%;
    min-height : auto;
  }

  /deep/ .el-checkbox {
    white-space : normal;
  }

  /deep/ .el-checkbox__label {
    width : 88%;
  }
}

@media screen and (max-width : 500px) {
  /deep/ .el-dialog {
    width : 95%;
  }

  .title > div {
    font-size : 24px;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  /deep/ .el-dialog {
    width : 80%;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  /deep/ .el-dialog {
    width : 75%;
  }

  .verificationContent {
    font-size : 20px;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {
  /deep/ .el-dialog {
    width     : 70%;
    max-width : 1200px;
  }

  .verificationContent {
    font-size : 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Register.vue